import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { class: "content-dashboard" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = { class: "reportes mb-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "reportes__tittle" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Marketing Send")
], -1)
const _hoisted_6 = { class: "reports__section1 tw-justify-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mt-5" }, " STATE ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select state", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "reports__button d-flex justify-content-center" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "reports__data mt-3 pb-3 position-relative" }
const _hoisted_14 = {
  key: 0,
  class: "text-center p-4"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "Loading data...", -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "w-100 bg-white p-3 rounded-4"
}
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = { class: "text-muted mb-0" }
const _hoisted_21 = {
  key: 0,
  class: "text-muted mb-0"
}
const _hoisted_22 = { class: "" }
const _hoisted_23 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "REAL STATE TEAM"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "LAST NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "COMPANY"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PHONE NUMBER"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "email-column"
    }, "EMAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "COUNTY"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ZIPCODE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SUBSYSTEM CODE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SENT DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ACTIONS")
  ])
], -1)
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select estate team name", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", null, "Realtor", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("option", null, "Broker", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", null, "MLO", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", null, "Company Title", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", null, "Inspector", -1)
const _hoisted_32 = [
  _hoisted_26,
  _hoisted_27,
  _hoisted_28,
  _hoisted_29,
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = { key: 1 }
const _hoisted_36 = ["onUpdate:modelValue"]
const _hoisted_37 = { key: 1 }
const _hoisted_38 = ["onUpdate:modelValue"]
const _hoisted_39 = { key: 1 }
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "email-column" }
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = { key: 1 }
const _hoisted_45 = ["onUpdate:modelValue", "onChange"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select county", -1)
const _hoisted_47 = ["value"]
const _hoisted_48 = { key: 1 }
const _hoisted_49 = ["onUpdate:modelValue"]
const _hoisted_50 = { key: 1 }
const _hoisted_51 = ["onUpdate:modelValue", "disabled"]
const _hoisted_52 = { value: null }
const _hoisted_53 = ["value"]
const _hoisted_54 = {
  key: 1,
  class: ""
}
const _hoisted_55 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { class: "d-flex gap-1" }
const _hoisted_58 = ["onClick", "disabled"]
const _hoisted_59 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status"
}
const _hoisted_60 = ["onClick", "disabled"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = ["onClick", "disabled", "title"]
const _hoisted_64 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_65 = {
  key: 1,
  class: "fas fa-trash"
}
const _hoisted_66 = {
  key: 2,
  class: "text-center p-4"
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-3" }, "No subsystem requests found for the selected state.", -1)

import { ref, onMounted, computed } from 'vue';
import TopBar from '@/components/admin/TopBar.vue';
import axios from 'axios';
import { environment } from "@/environment";
import { useToast } from "@/composables/useToast";


export default /*#__PURE__*/_defineComponent({
  __name: 'marketingSend',
  setup(__props) {

const toast = useToast();
const loading = ref(false);
const state = ref(null);
const county = ref(null);
const listStates = ref([]);
const listCounties = ref([]);
const listCodes = ref([]);
const subsystemData = ref([]);
const subsystemCodes = ref([]);
const loadingSubsystemCodes = ref({});
const url = environment.URL_API;

const newRows = computed(() => {
  return subsystemData.value.filter(item => item.isNew).length;
});

const formatDate = (dateString: string) => {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  } catch (error) {
    return '-';
  }
};

const isValidNewRequest = (data: any) => {
  return data.name && data.last_name && data.email && data.county && data.selectedCode;
};

const getSubsystemRequests = async () => {
  if (!state.value || state.value === null) {
    toast.error("Please select a state", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    return;
  }

  loading.value = true;
  subsystemData.value = [];
  subsystemCodes.value = [];

  try {
    const response = await axios({
      method: "GET",
      url: `${url}realtor-format/subsystem-code-complete`,
      params: {
        state: state.value.state
      }
    });

    if (response.data.success) {
      subsystemData.value = (response.data.request || []).map(item => ({
        ...item,
        isNew: false,
        availableCodes: []
      }));
    } else {
      toast.error("Error loading data: " + (response.data.message || 'Unknown error'), {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    toast.error("Error loading subsystem requests", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
  } finally {
    loading.value = false;
  }
};

const getCodesByCounty = async (data: any, index: number) => {
  if (!data.county || !state.value) {
    data.availableCodes = [];
    data.selectedCode = null;
    return;
  }

  loadingSubsystemCodes.value[index] = true;

  try {
    const response = await axios({
      method: "GET",
      url: `${url}realtor-format/get-codes-filtered`,
      params: {
        state: state.value.state,
        county: data.county,
        real_estate_team : data.real_estate_team
      }
    });

    if (response.data.success && response.data.codes) {
      data.availableCodes = Array.isArray(response.data.codes) ? response.data.codes : [];
      data.selectedCode = null;
    } else {
      data.availableCodes = [];
      toast.error("No codes found for selected county", {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  } catch (error) {
    console.error("Error loading codes for county:", error);
    data.availableCodes = [];
    toast.error("Error loading codes for county", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
  } finally {
    loadingSubsystemCodes.value[index] = false;
  }
};

const addNewRow = () => {
  const newRow = {
    ID: null,
    real_estate_team: '',
    name: '',
    last_name: '',
    company_name: '',
    phone_number: '',
    email: '',
    county: '',
    zip_code: '',
    selectedCode: null,
    code: null,
    createDate: null,
    isNew: true,
    availableCodes: []
  };

  subsystemData.value.push(newRow);
};

const saveNewRequest = async (data: any, index: number) => {
  if (!isValidNewRequest(data)) {
    toast.error("Please fill all required fields (Name, Last Name, Email, County, and Code)", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    return;
  }

  loadingSubsystemCodes.value[index] = true;

  try {
    if (data.ID == null) {
      const response = await axios(`${url}realtor-format/subsystem-request`, {
        method: "POST",
        data: {
          requestData: [{
            ID: null,
            real_estate_team: data.real_estate_team,
            name: data.name,
            last_name: data.last_name,
            company_name: data.company_name,
            phone_number: data.phone_number,
            email: data.email,
            state: state.value.state,
            county: data.county,
            zip_code: data.zip_code,
            code: data.selectedCode
          }],
        }
      });

      if (response.data.success) {

          data.ID = response.data.data?.id || response.data.id;
          data.code = data.selectedCode;
          data.createDate = new Date().toISOString();
          data.isNew = false;

          toast.success("Request saved successfully", {
            position: "top-end",
            timer: 3000,
            showCloseButton: true,
          });
        

      } else {
        toast.error(response.data.message || 'Error saving request', {
          position: "top-end",
          timer: 3000,
          showCloseButton: true,
        });
      }
    } else {
      const response = await axios({
        method: "PUT",
        url: `${url}realtor-format/update-request`,
        data: {
          ID: data.ID,
          code: data.selectedCode
        }
      });

      if (response.data.success) {
        data.code = data.selectedCode;

        toast.success(`Subsystem code updated successfully`, {
          position: "top-end",
          timer: 3000,
          showCloseButton: true,
        });
      } else {
        toast.error(response.data.message || 'Error updating record', {
          position: "top-end",
          timer: 3000,
          showCloseButton: true,
        });
      }
    }

  } catch (error) {
    console.error('Error saving request:', error);
    toast.error("Error saving request", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
  } finally {
    loadingSubsystemCodes.value[index] = false;
  }
};


const getCountiesByState = async () => {
  if (!state.value) {
    listCounties.value = [];
    return;
  }

  try {
    const response = await axios({
      method: "GET",
      url: `${url}realtor-format/get-county`,
      params: {
        state: state.value.state
      }
    });

    if (response.data.success) {
      listCounties.value = response.data.county;
    } else {
      toast.error("Error loading counties", {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  } catch (error) {
    toast.error("Error loading counties", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    console.error("Error:", error);
  }
};


const editRequest = async (data: any, index: number) => {
  data.isNew = true;
  data.selectedCode = data.code;
  data.availableCodes = [];

  if (data.county) {
    await getCodesByCounty(data, index);
  }
};

const deleteRequest = async (ID, index) => {
  
    subsystemData.value.splice(index, 1);
    const response = await axios(
        `${url}realtor-format/delete-subsystem-request`,
        {
            method: "DELETE",
            data: { ID },
        }
    );
    
};


const getStates = async () => {
  loading.value = true;
  try {
    const response = await axios({
      method: "GET",
      url: `${url}realtor-format/get-states`
    });

    if (response.data.success) {
      listStates.value = response.data.states;
    } else {
      toast.error("Error loading states", {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  } catch (error) {
    toast.error("Error loading states", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    console.error("Error:", error);
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  getStates();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TopBar),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _hoisted_7,
              _withDirectives((_openBlock(), _createElementBlock("select", {
                class: "form-select form-select-sm rounded-pill border-light shadow-sm px-3 py-2",
                style: {"width":"150px"},
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state).value = $event)),
                onChange: getCountiesByState,
                key: 'state-select'
              }, [
                _hoisted_8,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listStates.value, (state) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: state.state,
                    value: state
                  }, _toDisplayString(state.state), 9, _hoisted_9))
                }), 128))
              ], 32)), [
                [_vModelSelect, state.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary me-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (getSubsystemRequests())),
              disabled: loading.value || !state.value
            }, " GENERATE", 8, _hoisted_11),
            (state.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary me-2",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (addNewRow())),
                  disabled: !state.value || loading.value
                }, " ADD NEW REQUEST", 8, _hoisted_12))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
              : (subsystemData.value && subsystemData.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("h6", null, "Subsystem Requests for " + _toDisplayString(state.value?.state), 1),
                      _createElementVNode("p", _hoisted_20, "Total requests: " + _toDisplayString(subsystemData.value.filter(item => !item.isNew).length), 1),
                      (newRows.value > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_21, "New requests: " + _toDisplayString(newRows.value), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("table", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subsystemData.value, (data, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: data.ID || `new-${index}`,
                              class: _normalizeClass({ 'table-warning': data.isNew })
                            }, [
                              _createElementVNode("td", null, [
                                (data.isNew)
                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                      key: 0,
                                      class: "form-select form-select-sm border-light px-3 py-2",
                                      "onUpdate:modelValue": ($event: any) => ((data.real_estate_team) = $event)
                                    }, _hoisted_32, 8, _hoisted_25)), [
                                      [_vModelSelect, data.real_estate_team]
                                    ])
                                  : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(data.real_estate_team || '-'), 1))
                              ]),
                              _createElementVNode("td", null, [
                                (data.isNew)
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      "onUpdate:modelValue": ($event: any) => ((data.name) = $event),
                                      class: "form-control form-control-sm",
                                      placeholder: "Name"
                                    }, null, 8, _hoisted_34)), [
                                      [_vModelText, data.name]
                                    ])
                                  : (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(data.name || '-'), 1))
                              ]),
                              _createElementVNode("td", null, [
                                (data.isNew)
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      "onUpdate:modelValue": ($event: any) => ((data.last_name) = $event),
                                      class: "form-control form-control-sm",
                                      placeholder: "Last Name"
                                    }, null, 8, _hoisted_36)), [
                                      [_vModelText, data.last_name]
                                    ])
                                  : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(data.last_name || '-'), 1))
                              ]),
                              _createElementVNode("td", null, [
                                (data.isNew)
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      "onUpdate:modelValue": ($event: any) => ((data.company_name) = $event),
                                      class: "form-control form-control-sm",
                                      placeholder: "Company"
                                    }, null, 8, _hoisted_38)), [
                                      [_vModelText, data.company_name]
                                    ])
                                  : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(data.company_name || '-'), 1))
                              ]),
                              _createElementVNode("td", null, [
                                (data.isNew)
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      "onUpdate:modelValue": ($event: any) => ((data.phone_number) = $event),
                                      class: "form-control form-control-sm",
                                      placeholder: "Phone"
                                    }, null, 8, _hoisted_40)), [
                                      [_vModelText, data.phone_number]
                                    ])
                                  : (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(data.phone_number || '-'), 1))
                              ]),
                              _createElementVNode("td", _hoisted_42, [
                                (data.isNew)
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      "onUpdate:modelValue": ($event: any) => ((data.email) = $event),
                                      class: "form-control form-control-sm",
                                      placeholder: "Email",
                                      type: "email"
                                    }, null, 8, _hoisted_43)), [
                                      [_vModelText, data.email]
                                    ])
                                  : (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(data.email || '-'), 1))
                              ]),
                              _createElementVNode("td", null, [
                                (data.isNew)
                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                      key: 0,
                                      class: "form-select form-select-sm border-light px-3 py-2",
                                      "onUpdate:modelValue": ($event: any) => ((data.county) = $event),
                                      onChange: ($event: any) => (getCodesByCounty(data, index))
                                    }, [
                                      _hoisted_46,
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listCounties.value, (county) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: county.county,
                                          value: county.county
                                        }, _toDisplayString(county.county), 9, _hoisted_47))
                                      }), 128))
                                    ], 40, _hoisted_45)), [
                                      [_vModelSelect, data.county]
                                    ])
                                  : (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(data.county || '-'), 1))
                              ]),
                              _createElementVNode("td", null, [
                                (data.isNew)
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      "onUpdate:modelValue": ($event: any) => ((data.zip_code) = $event),
                                      class: "form-control form-control-sm",
                                      placeholder: "Zip Code",
                                      type: "number"
                                    }, null, 8, _hoisted_49)), [
                                      [_vModelText, data.zip_code]
                                    ])
                                  : (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(data.zip_code || '-'), 1))
                              ]),
                              _createElementVNode("td", null, [
                                (data.isNew)
                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                      key: 0,
                                      class: "form-select form-select-sm",
                                      "onUpdate:modelValue": ($event: any) => ((data.selectedCode) = $event),
                                      disabled: loadingSubsystemCodes.value[index] || !data.county
                                    }, [
                                      _createElementVNode("option", _hoisted_52, _toDisplayString(data.county ? 'Select Code' : 'Select County First'), 1),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.availableCodes || [], (code) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: code,
                                          value: code
                                        }, _toDisplayString(code), 9, _hoisted_53))
                                      }), 128))
                                    ], 8, _hoisted_51)), [
                                      [_vModelSelect, data.selectedCode]
                                    ])
                                  : (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(data.code || '-'), 1))
                              ]),
                              _createElementVNode("td", null, [
                                (data.isNew)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_55, "-"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(data.createDate), 1))
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_57, [
                                  (data.isNew)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "btn btn-success btn-sm",
                                        onClick: ($event: any) => (saveNewRequest(data, index)),
                                        disabled: loadingSubsystemCodes.value[index] || !isValidNewRequest(data),
                                        title: "Save new request"
                                      }, [
                                        (loadingSubsystemCodes.value[index])
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_59))
                                          : _createCommentVNode("", true),
                                        _createTextVNode(" " + _toDisplayString(loadingSubsystemCodes.value[index] ? 'SAVING...' : 'SAVE'), 1)
                                      ], 8, _hoisted_58))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: "btn btn-warning btn-sm",
                                        onClick: ($event: any) => (editRequest(data, index)),
                                        disabled: loadingSubsystemCodes.value[index],
                                        title: "Edit request"
                                      }, _hoisted_62, 8, _hoisted_60)),
                                  _createElementVNode("button", {
                                    class: "btn btn-danger btn-sm",
                                    onClick: ($event: any) => (deleteRequest(data.ID, index)),
                                    disabled: loadingSubsystemCodes.value[index],
                                    title: data.isNew ? 'Cancel new request' : 'Delete request'
                                  }, [
                                    (loadingSubsystemCodes.value[index])
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_64))
                                      : (_openBlock(), _createElementBlock("i", _hoisted_65))
                                  ], 8, _hoisted_63)
                                ])
                              ])
                            ], 2))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                : (!loading.value && state.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                      _hoisted_67,
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-success",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (addNewRow()))
                      }, " ADD FIRST REQUEST ")
                    ]))
                  : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})